import { render, staticRenderFns } from "./mv-wd-task-option-menu-createppt.vue?vue&type=template&id=24c3be7c"
import script from "./mv-wd-task-option-menu-createppt.vue?vue&type=script&lang=js"
export * from "./mv-wd-task-option-menu-createppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports